import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c987afd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3c987afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c987afd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSvg: require('/builds/wj/fe/wenjuan-homesite/components/common/svg.vue').default})
